import type { User } from '@/types';
import type { ChangePasswordDto, RegisterUserDto, SignInUserDto } from '@/types/dto/auth.dto';
import { createContext } from 'react';

export interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  signIn: (data: SignInUserDto) => Promise<void>;
  signUp: (data: RegisterUserDto) => Promise<void>;
  changePassword: (data: ChangePasswordDto) => Promise<void>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
